import React, { createContext, useContext, useState, useEffect } from "react";
import { useLocation } from "react-router-dom";

interface SidebarContextType {
  showChatHistory: boolean;
  setShowChatHistory: (show: boolean) => void;
  toggleChatHistory: () => void;
}

const SidebarContext = createContext<SidebarContextType | undefined>(undefined);

export const SidebarProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const location = useLocation();
  const pathname = location.pathname;
  const [showChatHistory, setShowChatHistory] = useState(
    pathname.startsWith("/chat") ? true : false,
  );

  // Update showChatHistory when pathname changes
  useEffect(() => {
    if (pathname.startsWith("/chat")) {
      setShowChatHistory(true);
    } else {
      setShowChatHistory(false);
    }
  }, [pathname]);

  const toggleChatHistory = () => {
    setShowChatHistory(!showChatHistory);
  };

  return (
    <SidebarContext.Provider value={{ showChatHistory, setShowChatHistory, toggleChatHistory }}>
      {children}
    </SidebarContext.Provider>
  );
};

export const useSidebar = () => {
  const context = useContext(SidebarContext);

  if (context === undefined) {
    throw new Error("useSidebar must be used within a SidebarProvider");
  }

  return context;
};
